import React from 'react';
import heroSvg from '../../assets/hero.svg';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation('hero');
  return (
    <section id='top'>
      <div className='container tc'>
        <div className='s-40 sm-60'></div>
        <h1 className='title-intro'>
          {t('hero.title')}
        </h1>
        <div className='s-24'></div>
        <h3 className='title-intro-sub w-60 ma'>
          {t('hero.subtitle')}
        </h3>
        <div className='s-32'></div>
        <a href='#cta' className='button'>
          {t('hero.cta')}
        </a>
        <div className='s-32'></div>
        <p className='title-mini'>
          {t('hero.description')}
        </p>
        <div className='s-48'></div>
        <img
          src={heroSvg}
          alt='AI Neural Network'
          width={500}
          height={500}
          className='hero-image'
        />
        <div className='s-48'></div>
      </div>
      <div className='back'></div>
    </section>
  );
};

export { Hero };
